export const css = {
	root: '_1LWJf6EO',
	' _key': 'ascm-theme/ascm/variants/cpim2024'
};

export default css;
